import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#242433",
  "fill-rule": "evenodd",
  d: "M11 21.083c5.569 0 10.083-4.514 10.083-10.083S16.57.917 11 .917.917 5.43.917 11 5.43 21.083 11 21.083M19.25 11a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0m-12.14-.917a.917.917 0 0 0 0 1.834h2.973v2.972a.917.917 0 0 0 1.834 0v-2.972h2.972a.917.917 0 0 0 0-1.834h-2.972V7.111a.917.917 0 0 0-1.834 0v2.972z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }